<script>
import { mapState } from 'vuex'
import { permiteAction } from '@/service/acao'
import portuguese from 'vee-validate/dist/locale/pt_BR'

export default {
  computed: {
    ...mapState({
      httpLoading: state => state.httpLoading,
      usuario: state => state.auth.usuario
    })
  },
  methods: {
    acao: function (ident) {
      return permiteAction(ident)
    }
  },
  created () {
    this.$validator.localize('pt_BR', {
      messages: portuguese.messages
    })
    this.$validator.localize('pt_BR')
  }
}
</script>
<template>
  <div>
    <div class="suporte whatsapp" v-if="usuario && usuario.id && acao('ver_suporte')">
      <a class="fa fa-whatsapp" v-b-popover.hover.top="'Clique para falar com a gente'"
        href="https://wa.me/5517991871188" target="_blank" />
    </div>
    <router-view />
    <div class="loader" v-show="httpLoading">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  </div>
</template>
<style>
</style>




// WEBPACK FOOTER //
// main.vue?0a0bc479